import React, { useState } from 'react'
import { useTransition } from 'react-spring'
import {
    CarouselCard,
    Container,
    CarouselWrapper,
    CarouselIconButton,
    CarouselDot,
    DotsWrapper,
    Component,
} from './CarouselComponent.css'
import ArrowBackIcon from 'assets/icons/prev-carousel-arrow.svg'
import ArrowForwardIcon from 'assets/icons/next-carousel-arrow.svg'
import { useToggleState } from 'lib/hooks/useToggleState'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import TestimonialCard from 'components/modules/LandingPage/TestimonialCard'

interface CarouselProps {
    carouselData: {
        text: string
        imageWebp: StaticImageData | string
        footerInfo?: {
            title: string
            subtitle: string
        }
    }[]
}

export default function CarouselComponent({ carouselData }: CarouselProps) {
    const [count, setCount] = useState(0)
    const [direction, toggleDirection] = useToggleState(false)
    const md = useMedia(deviceSize.md)
    const transitions = useTransition([count], (item) => item, {
        from: {
            transform: `translate3d(${direction ? '' : '-'}${md ? 0 : '25%'},0,0)`,
            opacity: 0,
            position: 'absolute',
        },
        enter: { transform: 'translate3d(0,0,0)', opacity: 1 },
        leave: {
            opacity: 0,
            transform: `translate3d(${direction ? '-' : ''}${md ? 0 : '25%'},0,0)`,
        },
    })

    const prevSlide = () => {
        if (direction) toggleDirection()
        const prevSlide = count - 1 < 0 ? carouselData.length - 1 : count - 1
        setCount(prevSlide)
    }

    const nextSlide = () => {
        if (!direction) toggleDirection()
        const nextSlide = count + 1 < carouselData.length ? count + 1 : 0
        setCount(nextSlide)
    }

    const toggleDot = (index: number) => {
        if (index > count) {
            if (!direction) toggleDirection()
        } else {
            if (direction) toggleDirection()
        }
        setCount(index)
    }

    return (
        <Component>
            <Container>
                {!md ? (
                    <CarouselIconButton onClick={prevSlide} isLeft>
                        <div className="circle">
                            <ArrowBackIcon />
                        </div>
                    </CarouselIconButton>
                ) : null}
                <CarouselWrapper>
                    {transitions.map(({ item, props, key }) => {
                        const data = carouselData[item]
                        return (
                            <CarouselCard key={key} style={props}>
                                <TestimonialCard {...data} />
                            </CarouselCard>
                        )
                    })}
                </CarouselWrapper>
                {!md ? (
                    <CarouselIconButton onClick={nextSlide}>
                        <div className="circle">
                            <ArrowForwardIcon />
                        </div>
                    </CarouselIconButton>
                ) : null}
            </Container>
            <DotsWrapper>
                {md ? (
                    <CarouselIconButton onClick={prevSlide} isLeft>
                        <div className="circle">
                            <ArrowBackIcon />
                        </div>
                    </CarouselIconButton>
                ) : null}
                {carouselData.map((_, i) => (
                    <CarouselDot key={`carousel-dot-${i}`} isClicked={count === i} onClick={() => toggleDot(i)} />
                ))}
                {md ? (
                    <CarouselIconButton onClick={nextSlide}>
                        <div className="circle">
                            <ArrowForwardIcon />
                        </div>
                    </CarouselIconButton>
                ) : null}
            </DotsWrapper>
        </Component>
    )
}
